import { defaultAutGroupDto, AutGroupDto } from "src/dtos/autGroup/autGroupDto";
import { defaultSysCodeDto, SysCodeDto } from "src/dtos/code/sysCodeDto";

export interface SYS3060_R01HeaderDto extends SysCodeDto {
	
}

export const defaultSYS3060_R01HeaderDto: SYS3060_R01HeaderDto = {
	...defaultSysCodeDto,
	minorCd: `$`,
};


/**
 * SYS3060_R01 - 권한 그룹별 메뉴 권한 관리 DTO
 */
export interface SYS3060_R01Dto extends AutGroupDto {
    systemCd: string;
    menuNm: string;
    useYn: string;
	listLength?: number;
	refetchListLength?: number;
}

export const defaultSYS3060_R01Dto: SYS3060_R01Dto = {
	...defaultAutGroupDto,
    systemCd: '',
    menuNm: '',
    useYn: '',
	listLength: 0,
	refetchListLength: 0,
};
